import Image from 'components/Image';
import styled from 'styled-components';

export const FitImage = styled(Image)`
    img {
        object-fit: cover;
    }
`;
